export default __webpack_public_path__ + "static/wtu_main-605099e13ab91818cb200456c6a1a903.jpg";